module.exports = __webpack_public_path__ + "img/38fcb5a37082bad7.png";